import { Component, OnInit, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SafeUrl } from '@angular/platform-browser';
import { ModalComponent } from '@kiwid-app/kiwid-ui-lib-angular';

@Component({
    selector: 'app-modal-image',
    templateUrl: './modal-image.component.html',
    styleUrls: ['./modal-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class ModalImageComponent implements OnInit {
    public dialog: Signal<MatDialogRef<ModalComponent, string>>;
    public imageUrl: Signal<string | SafeUrl>;

    constructor() {}

    ngOnInit(): void {}
}
